import axios from 'axios'
import { callGet, callPost, callPostForBlob } from '../../services/axios'
// import { endpoint } from '../../config/api'
import { toast } from '../../components/CommonComponents/ToastComponent/toast'

import {
  GET_CHILD_SUPPLIERS_START,
  GET_CHILD_SUPPLIERS_SUCCESS,
  GET_CHILD_SUPPLIERS_FAILED,
  GET_CHILD_SUPPLIERS_WITH_MASTER_IDS_START,
  GET_CHILD_SUPPLIERS_WITH_MASTER_IDS_SUCCESS,
  GET_CHILD_SUPPLIERS_WITH_MASTER_IDS_FAIL,
  GET_CHILD_SUPPLIERS_WITH_MASTER_ID_START,
  GET_CHILD_SUPPLIERS_WITH_MASTER_ID_SUCCESS,
  GET_CHILD_SUPPLIERS_WITH_MASTER_ID_FAIL,
  GET_MASTER_SUPPLIERS_START,
  GET_MASTER_SUPPLIERS_SUCCESS,
  GET_MASTER_SUPPLIERS_FAILED,
  GET_MASTER_SUPPLIER_DETAILS_BY_ID_START,
  GET_MASTER_SUPPLIER_DETAILS_BY_ID_SUCCESS,
  GET_MASTER_SUPPLIER_DETAILS_BY_ID_FAIL,
  ASSIGN_MASTER_START,
  ASSIGN_MASTER_SUCCESS,
  ASSIGN_MASTER_FAILED,
  REMOVE_MASTER_START,
  REMOVE_MASTER_SUCCESS,
  REMOVE_MASTER_FAILED,
  CREATE_MASTER_FROM_CHILDS_START,
  CREATE_MASTER_FROM_CHILDS_SUCCESS,
  CREATE_MASTER_FROM_CHILDS_FAIL,
  UPDATE_SUPPLIER_BASIC_INFO_START,
  UPDATE_SUPPLIER_BASIC_INFO_SUCCESS,
  UPDATE_SUPPLIER_BASIC_INFO_FAIL,
  UPDATE_SUPPLIER_CARD_INFO_START,
  UPDATE_SUPPLIER_CARD_INFO_SUCCESS,
  UPDATE_SUPPLIER_CARD_INFO_FAIL,
  UPDATE_SUPPLIER_PAYMENT_INFO_START,
  UPDATE_SUPPLIER_PAYMENT_INFO_SUCCESS,
  UPDATE_SUPPLIER_PAYMENT_INFO_FAIL,
  UPDATE_SUPPLIER_DETAIL_INFO_START,
  UPDATE_SUPPLIER_DETAIL_INFO_SUCCESS,
  UPDATE_SUPPLIER_DETAIL_INFO_FAIL,
  GET_CHILD_SUPPLIERS_FOR_QA_START,
  GET_CHILD_SUPPLIERS_FOR_QA_SUCCSS,
  GET_CHILD_SUPPLIERS_FOR_QA_FAIL,
  GET_MASTER_SUPPLIERS_FOR_QA_START,
  GET_MASTER_SUPPLIERS_FOR_QA_SUCCSS,
  GET_MASTER_SUPPLIERS_FOR_QA_FAIL,
  APPROVE_SUPPLIERS_START,
  APPROVE_SUPPLIERS_SUCCESS,
  APPROVE_SUPPLIERS_FAIL,
  REJECT_SUPPLIERS_START,
  REJECT_SUPPLIERS_SUCCESS,
  REJECT_SUPPLIERS_FAIL,
  ADD_SUPPLIER_CARD_EMAIL_INFO_START,
  ADD_SUPPLIER_CARD_EMAIL_INFO_SUCCESS,
  ADD_SUPPLIER_CARD_EMAIL_INFO_FAIL,
  REMOVE_SUPPLIER_CARD_EMAIL_INFO_START,
  REMOVE_SUPPLIER_CARD_EMAIL_INFO_SUCCESS,
  REMOVE_SUPPLIER_CARD_EMAIL_INFO_FAIL,
  GET_RELATED_SUPPLIER_WITH_ID_START,
  GET_RELATED_SUPPLIER_WITH_ID_SUCCESS,
  GET_RELATED_SUPPLIER_WITH_ID_FAIL,
  ADD_SUPPLIER_HISTORY_START,
  ADD_SUPPLIER_HISTORY_SUCCESS,
  ADD_SUPPLIER_HISTORY_FAIL,
  GET_ALL_SUPPLIERS_DATA_START,
  GET_ALL_SUPPLIERS_DATA_SUCCESS,
  GET_ALL_SUPPLIERS_DATA_FAIL,
  REMOVE_MASTER_SUPPLIER_DETAILS,
  GET_LOCATION_BASED_MASTER_SUPPLIERS_START,
  GET_LOCATION_BASED_MASTER_SUPPLIERS_SUCCESS,
  GET_LOCATION_BASED_MASTER_SUPPLIERS_FAILED,
  GET_ALL_MASTER_SUPPLIERS_DATA_START,
  GET_ALL_MASTER_SUPPLIERS_DATA_SUCCESS,
  GET_ALL_MASTER_SUPPLIERS_DATA_FAIL,
  GET_LOCATION_BASED_MASTER_SUPPLIERS_FOR_QA_START,
  GET_LOCATION_BASED_MASTER_SUPPLIERS_FOR_QA_SUCCESS,
  GET_LOCATION_BASED_MASTER_SUPPLIERS_FOR_QA_FAIL,
  CREATE_CHILD_START,
  CREATE_CHILD_SUCCESS,
  CREATE_CHILD_FAIL,
  UPDATE_GLOBAL_ACCEPTANCE
} from '../actionTypes/vendor'
import { getContactsByIds } from './contact'

// const endpoint = process.env.REACT_APP_API_ENDPOINT

export const getChildSuppliersStart = () => {
  return { type: GET_CHILD_SUPPLIERS_START }
}
export const getChildSuppliersSuccess = (data, searchListLength, noMaster, hasMaster, contacts = []) => {
  return { type: GET_CHILD_SUPPLIERS_SUCCESS, data, searchListLength, noMaster, hasMaster, contacts }
}
export const getChildSuppliersFailed = () => {
  return { type: GET_CHILD_SUPPLIERS_FAILED }
}

export const getChildSuppliers = (data) => async (dispatch, getState) => {
  const { auth: { user, token } } = getState()
  const { id } = user
  const { limit, offset, noMaster, hasMaster, sortColumn, sortType, isMasterDetailsRequired } = data;
  var searchListLength = data?.searchList ? Object.keys(data?.searchList)?.length : 0
  var searchList = JSON?.stringify(data?.searchList)
  dispatch(getChildSuppliersStart())
  return callGet(`/api/supplier/getChildSuppliersByUser`, token, {
    userId: id,
    offset: offset,
    limit: limit,
    searchList,
    noMaster,
    hasMaster,
    sortColumn,
    sortType,
    isMasterDetailsRequired
  }).then(async (res) => {
    const suppliers = res['data']?.childSuppliers
    const cardAccData = res['data']?.cardAcceptance || []
    const paymentData = res['data']?.payment || []
    const supDetailsData = res['data']?.supDetails || []
    const total = res['data']?.total || 0
    var tmpChildSuppliers = []
    if (suppliers && suppliers?.length > 0) {
      const getMasterSuppliers = async (masterIds) => {
        const data = await dispatch(getMasterSuppliersByIds({ primaryMasterId: false, masterIds })).then(res => {
          return res
        })
        return data
      }

      const getChildSuppliersCount = async (searchList, noMaster, hasMaster) => {
        const data = await dispatch(getChildSuppliersByUserCount({ searchList, noMaster, hasMaster })).then(res => {
          return res?.totalChildren || 0
        })
        return data
      }
      const supEmails = suppliers?.map(data => data?.email && /^\d+$/.test(data?.email) ? data?.email : null)
      const supPhones = suppliers?.map(data => data?.phone && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.phone) && /^\d+$/.test(data?.phone) ? data?.phone : null)
      const cardPhones = cardAccData?.map(data => data?.cardPaymentByPhoneValue && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.cardPaymentByPhoneValue) && /^\d+$/.test(data?.cardPaymentByPhoneValue) ? data?.cardPaymentByPhoneValue : null)
      const cardIvrPhones = cardAccData?.map(data => data?.cardPaymentIVRPhone && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.cardPaymentIVRPhone) && /^\d+$/.test(data?.cardPaymentIVRPhone) ? data?.cardPaymentIVRPhone : null)
      const paymentEmails = paymentData?.map(data => data?.emailAch && /^\d+$/.test(data?.emailAch) ? data?.emailAch : null)
      let contactIds = []
      let allContactIds = contactIds.concat(supEmails, supPhones, cardPhones, cardIvrPhones, paymentEmails);
      contactIds = allContactIds?.filter(data => data && /^\d+$/.test(data))
      const uniqueContactIds = [...new Set(contactIds)]

      if (uniqueContactIds && uniqueContactIds?.length) {
        res['data'].contacts = await getAllContactsByIds(uniqueContactIds, dispatch)
      } else {
        res['data'].contacts = []
      }

      const masterIds = suppliers?.map(sup => sup?.masterId)
      const masterSuppliers = await getMasterSuppliers(masterIds)
      res['data'].totalChilds = total // await getChildSuppliersCount(searchList, noMaster, hasMaster)

      for (var i = 0; i < suppliers?.length; i++) {
        const masterSupplierIndex = masterSuppliers.findIndex(masterSupplier => masterSupplier.id === suppliers?.[i].masterId)
        const cardData = cardAccData?.find(cardData => cardData?.supplierId === suppliers?.[i]?.id)
        const payment = paymentData?.find(payment => payment?.supplierId === suppliers?.[i]?.id)
        const supDetail = supDetailsData?.find(detail => detail?.supplierId === suppliers?.[i]?.id)
        const supplierQARole = supDetail?.approvedByQA
        tmpChildSuppliers[i] = suppliers?.[i];
        tmpChildSuppliers[i]['masterSupplierName'] = masterSupplierIndex !== -1 ? masterSuppliers?.[masterSupplierIndex]?.suppliername : null
        tmpChildSuppliers[i]['masterSupplierInfo'] = masterSupplierIndex !== -1 ? masterSuppliers?.[masterSupplierIndex] : null
        tmpChildSuppliers[i]['supplierQARole'] = supplierQARole === 8 ? 'Approved' : supplierQARole === 7 ? 'Rejected' : 'Pending'
        tmpChildSuppliers[i]['contactDate'] = supDetail?.contactDate
        tmpChildSuppliers[i]['cardAcceptance'] = cardData || {}
        tmpChildSuppliers[i]['payment'] = payment || {}
        tmpChildSuppliers[i]['supplierDetail'] = supDetail || {}
        if (isMasterDetailsRequired) {
          const masterCardAcc = cardAccData?.find(cardData => cardData?.supplierId === suppliers?.[i]?.masterId)
          tmpChildSuppliers[i]['masterCardAcc'] = masterCardAcc || {}
        }

        tmpChildSuppliers[i].phone = tmpChildSuppliers[i]?.phone && /^\d+$/.test(tmpChildSuppliers[i]?.phone) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpChildSuppliers[i]?.phone) ? res['data'].contacts?.find(data => data?.id === parseInt(tmpChildSuppliers[i].phone))?.phone : (tmpChildSuppliers[i]?.phone || '')
        tmpChildSuppliers[i].email = tmpChildSuppliers[i]?.email && /^\d+$/.test(tmpChildSuppliers[i]?.email) ? res['data'].contacts?.find(data => data?.id === parseInt(tmpChildSuppliers[i]?.email))?.email : (tmpChildSuppliers[i]?.email || '')
        tmpChildSuppliers[i].cardAcceptance.cardPaymentByPhoneValue = tmpChildSuppliers[i]?.cardAcceptance?.cardPaymentByPhoneValue && /^\d+$/.test(tmpChildSuppliers[i]?.cardAcceptance?.cardPaymentByPhoneValue) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpChildSuppliers[i]?.cardAcceptance?.cardPaymentByPhoneValue) ? res['data'].contacts?.find(data => data?.id === parseInt(tmpChildSuppliers[i]?.cardAcceptance?.cardPaymentByPhoneValue))?.phone : (tmpChildSuppliers[i]?.cardAcceptance?.cardPaymentByPhoneValue || '')
        tmpChildSuppliers[i].cardAcceptance.cardPaymentIVRPhone = tmpChildSuppliers[i]?.cardAcceptance?.cardPaymentIVRPhone && /^\d+$/.test(tmpChildSuppliers[i]?.cardAcceptance?.cardPaymentIVRPhone) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpChildSuppliers[i]?.cardAcceptance?.cardPaymentIVRPhone) ? res['data'].contacts?.find(data => data?.id === parseInt(tmpChildSuppliers[i]?.cardAcceptance?.cardPaymentIVRPhone))?.phone : (tmpChildSuppliers[i]?.cardAcceptance?.cardPaymentIVRPhone || '')
        tmpChildSuppliers[i].payment.emailAch = tmpChildSuppliers[i]?.payment?.emailAch && /^\d+$/.test(tmpChildSuppliers[i]?.payment?.emailAch) ? res['data'].contacts?.find(data => data?.id === parseInt(tmpChildSuppliers[i]?.payment?.emailAch))?.email : (tmpChildSuppliers[i]?.payment?.emailAch || '')
      }
      res['data'].childSuppliers = tmpChildSuppliers
    } else {
      res['data'].childSuppliers = []
      res['data'].totalChilds = 0
    }

    dispatch(getChildSuppliersSuccess(res['data']?.childSuppliers, searchListLength, noMaster, hasMaster, res['data'].contacts))
    return Promise.resolve(res['data'])
  }).catch((err) => {
    dispatch(getChildSuppliersFailed())
    return Promise.reject(err)
  })
}

export const getMasterSuppliersStart = () => {
  return { type: GET_MASTER_SUPPLIERS_START }
}
export const getMasterSuppliersSuccess = (data, searchListLength, contacts = []) => {
  return { type: GET_MASTER_SUPPLIERS_SUCCESS, data, searchListLength, contacts }
}
export const getMasterSuppliersFailed = () => {
  return { type: GET_MASTER_SUPPLIERS_FAILED }
}

export const getMasterSupplierDetailsById = (id, isStoreToRedux = true) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  if (isStoreToRedux) {
    dispatch({
      type: GET_MASTER_SUPPLIER_DETAILS_BY_ID_START,
    })
  }
  return callGet(`/api/supplier/getMasterSupplierDetailByMasterId`, token, {
    id: id
  }).then((res) => {
    if (isStoreToRedux) {
      dispatch({
        type: GET_MASTER_SUPPLIER_DETAILS_BY_ID_SUCCESS,
        data: res['data']
      })
    }
    return Promise.resolve(res['data'])
  }).catch(err => {
    if (isStoreToRedux) {
      dispatch({
        type: GET_MASTER_SUPPLIER_DETAILS_BY_ID_FAIL,
      })
    }
    return Promise.reject(err)
  })
}

export const getChildSuppliersWithMasterId = (masterId, listSupplierId = null, isInCalls = null, isFromCalls = false, isFromLocationMaster = false, vendorInCallDetailsId = null) => (dispatch, getState) => {
  const { auth: { user, token } } = getState()
  const { id } = user
  if (!isFromCalls && !isFromLocationMaster) {
    dispatch({
      type: GET_CHILD_SUPPLIERS_WITH_MASTER_ID_START
    })
  }
  return callGet(`/api/supplier/getChildSuppliersWithMasterId`, token, {
    userId: id,
    masterId: masterId,
    listSupplierId,
    isInCalls,
    vendorInCallDetailsId
  }).then((res) => {
    if (!isFromCalls && !isFromLocationMaster) {
      dispatch({
        type: GET_CHILD_SUPPLIERS_WITH_MASTER_ID_SUCCESS,
        data: res['data']
      })
    }
    return Promise.resolve(res['data'])
  }).catch(err => {
    if (!isFromCalls && !isFromLocationMaster) {
      dispatch({
        type: GET_CHILD_SUPPLIERS_WITH_MASTER_ID_FAIL,
      })
    }

    toast.show({
      title: 'Warning',
      description: 'Failed to get child suppliers for the selected master record!',
    })
    return Promise.reject(err)
  })
}




export const getChildSuppliersWithMasterIds = (ids, limit, offset) => async (dispatch, getState) => {
  const { auth: { user, token } } = getState()
  const { id } = user

  dispatch({
    type: GET_CHILD_SUPPLIERS_WITH_MASTER_IDS_START
  })
  return callGet(`/api/supplier/getChildSuppliersWithMasterIds`, token, {
    userId: id,
    masterIds: ids.join(','),
    limit,
    offset
  }).then(async (res) => {
    const suppliers = res['data']?.childSuppliers
    const cardAccData = res['data']?.cardAcceptance || []
    const paymentData = res['data']?.payment || []
    const supDetailsData = res['data']?.supDetails || []
    var tmpChildSuppliers = []
    if (suppliers && suppliers?.length > 0) {
      let contactIds = []
      let contacts = []
      const getMasterSuppliers = async (masterIds) => {
        const data = await dispatch(getMasterSuppliersByIds({ primaryMasterId: false, masterIds })).then(res => {
          return res
        })
        return data
      }

      const masterIds = suppliers?.map(sup => sup?.masterId)
      const masterSuppliers = await getMasterSuppliers(masterIds)
      res['data'].totalChilds = res['data']?.totalChilds || 0

      const supEmails = suppliers?.map(data => data?.email && /^\d+$/.test(data?.email) ? data?.email : null)
      const supPhones = suppliers?.map(data => data?.phone && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.phone) && /^\d+$/.test(data?.phone) ? data?.phone : null)
      const cardPhones = cardAccData?.map(data => data?.cardPaymentByPhoneValue && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.cardPaymentByPhoneValue) && /^\d+$/.test(data?.cardPaymentByPhoneValue) ? data?.cardPaymentByPhoneValue : null)
      const cardIvrPhones = cardAccData?.map(data => data?.cardPaymentIVRPhone && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.cardPaymentIVRPhone) && /^\d+$/.test(data?.cardPaymentIVRPhone) ? data?.cardPaymentIVRPhone : null)
      const paymentEmails = paymentData?.map(data => data?.emailAch && /^\d+$/.test(data?.emailAch) ? data?.emailAch : null)
      let allContactIds = contactIds.concat(supEmails, supPhones, cardPhones, cardIvrPhones, paymentEmails);
      contactIds = allContactIds?.filter(data => data && /^\d+$/.test(data))
      const uniqueContactIds = [...new Set(contactIds)]

      if (uniqueContactIds && uniqueContactIds?.length) {
        contacts = await getAllContactsByIds(uniqueContactIds, dispatch)
      }

      for (var i = 0; i < suppliers?.length; i++) {
        const masterSupplierIndex = masterSuppliers.findIndex(masterSupplier => masterSupplier.id === suppliers?.[i].masterId)
        const cardData = cardAccData?.find(cardData => cardData?.supplierId === suppliers?.[i]?.id)
        const payment = paymentData?.find(payment => payment?.supplierId === suppliers?.[i]?.id)
        const supDetail = supDetailsData?.find(detail => detail?.supplierId === suppliers?.[i]?.id)
        const supplierQARole = supDetail?.approvedByQA
        tmpChildSuppliers[i] = suppliers?.[i];
        tmpChildSuppliers[i]['masterSupplierName'] = masterSupplierIndex !== -1 ? masterSuppliers?.[masterSupplierIndex]?.suppliername : null
        tmpChildSuppliers[i]['masterSupplierInfo'] = masterSupplierIndex !== -1 ? masterSuppliers?.[masterSupplierIndex] : null
        tmpChildSuppliers[i]['supplierQARole'] = supplierQARole === 8 ? 'Approved' : supplierQARole === 7 ? 'Rejected' : 'Pending'
        tmpChildSuppliers[i]['contactDate'] = supDetail?.contactDate
        tmpChildSuppliers[i]['cardAcceptance'] = cardData || {}
        tmpChildSuppliers[i]['payment'] = payment || {}
        tmpChildSuppliers[i]['supplierDetail'] = supDetail || {}
        // set email and phone
        tmpChildSuppliers[i].phone = tmpChildSuppliers[i]?.phone && /^\d+$/.test(tmpChildSuppliers[i]?.phone) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpChildSuppliers[i]?.phone) ? contacts?.find(data => data?.id === parseInt(tmpChildSuppliers[i]?.phone))?.phone : (tmpChildSuppliers[i]?.phone || '')
        tmpChildSuppliers[i].email = tmpChildSuppliers[i]?.email && /^\d+$/.test(tmpChildSuppliers[i]?.email) ? contacts?.find(data => data?.id === parseInt(tmpChildSuppliers[i]?.email))?.email : (tmpChildSuppliers[i]?.email || '')
        tmpChildSuppliers[i].cardAcceptance.cardPaymentByPhoneValue = tmpChildSuppliers[i]?.cardAcceptance?.cardPaymentByPhoneValue && /^\d+$/.test(tmpChildSuppliers[i]?.cardAcceptance?.cardPaymentByPhoneValue) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpChildSuppliers[i]?.cardAcceptance?.cardPaymentByPhoneValue) ? contacts?.find(data => data?.id === parseInt(tmpChildSuppliers[i]?.cardAcceptance?.cardPaymentByPhoneValue))?.phone : (tmpChildSuppliers[i]?.cardAcceptance?.cardPaymentByPhoneValue || '')
        tmpChildSuppliers[i].cardAcceptance.cardPaymentIVRPhone = tmpChildSuppliers[i]?.cardAcceptance?.cardPaymentIVRPhone && /^\d+$/.test(tmpChildSuppliers[i]?.cardAcceptance?.cardPaymentIVRPhone) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpChildSuppliers[i]?.cardAcceptance?.cardPaymentIVRPhone) ? contacts?.find(data => data?.id === parseInt(tmpChildSuppliers[i]?.cardAcceptance?.cardPaymentIVRPhone))?.phone : (tmpChildSuppliers[i]?.cardAcceptance?.cardPaymentIVRPhone || '')
        tmpChildSuppliers[i].payment.emailAch = tmpChildSuppliers[i]?.payment?.emailAch && /^\d+$/.test(tmpChildSuppliers[i]?.payment?.emailAch) ? contacts?.find(data => data?.id === parseInt(tmpChildSuppliers[i]?.payment?.emailAch))?.email : (tmpChildSuppliers[i]?.payment?.emailAch || '')
      }
      res['data'].childSuppliers = tmpChildSuppliers
    } else {
      res['data'].childSuppliers = []
      res['data'].totalChilds = 0
    }
    dispatch({
      type: GET_CHILD_SUPPLIERS_WITH_MASTER_IDS_SUCCESS,
      data: res['data']
    })
    return Promise.resolve(res['data'])
  }).catch(err => {
    dispatch({
      type: GET_CHILD_SUPPLIERS_WITH_MASTER_IDS_FAIL,
    })
    toast.show({
      title: 'Warning',
      description: 'Failed to get child suppliers for the selected master record!',
    })
    return Promise.reject(err)
  })
}



export const getMasterSuppliers = (data) => (dispatch, getState) => {
  const { auth: { user, token } } = getState()
  const { id } = user
  const { limit, offset, sortColumn, sortType } = data
  var searchListLength = data?.searchList ? Object.keys(data?.searchList)?.length : 0
  var searchList = JSON?.stringify(data?.searchList)

  dispatch(getMasterSuppliersStart())
  return callGet(`/api/supplier/getMasterSuppliersByUser`, token, {
    userId: id,
    limit,
    offset,
    searchList,
    sortColumn,
    sortType
  }).then(async (res) => {
    const suppliers = res['data']?.masterSuppliers || []
    const cardEmailsData = res['data']?.cardEmails || []
    const cardAccData = res['data']?.cardAcceptance || []
    const paymentData = res['data']?.payment || []
    const supDetailsData = res['data']?.supDetails || []
    const total = res['data']?.total || 0
    var tmpChildSuppliers = []
    var tmpSuppliers = []

    const supEmails = suppliers?.map(data => data?.email && /^\d+$/.test(data?.email) ? data?.email : null)
    const supPhones = suppliers?.map(data => data?.phone && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.phone) && /^\d+$/.test(data?.phone) ? data?.phone : null)
    const cardPhones = cardAccData?.map(data => data?.cardPaymentByPhoneValue && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.cardPaymentByPhoneValue) && /^\d+$/.test(data?.cardPaymentByPhoneValue) ? data?.cardPaymentByPhoneValue : null)
    const cardIvrPhones = cardAccData?.map(data => data?.cardPaymentIVRPhone && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.cardPaymentIVRPhone) && /^\d+$/.test(data?.cardPaymentIVRPhone) ? data?.cardPaymentIVRPhone : null)
    const paymentEmails = paymentData?.map(data => data?.emailAch && /^\d+$/.test(data?.emailAch) ? data?.emailAch : null)
    const cardEmails = cardEmailsData?.map(data => data?.email && /^\d+$/.test(data?.email) ? data?.email : null)

    const getChildSuppliers = async (masterIds) => {
      const data = await dispatch(getChildSuppliersByIds({ isLocationMaster: false, masterIds })).then(res => {
        return res
      })
      return data
    }

    const getMasterSuppliersCount = async (searchList) => {
      const data = await dispatch(getMasterSuppliersByUserCount({ searchList })).then(res => {
        return res?.totalMasters || 0
      })
      return data
    }

    if (suppliers && suppliers.length > 0) {
      const supplierIds = suppliers?.map(sup => sup?.id)
      const childSuppliersData = await getChildSuppliers(supplierIds)
      res['data'].totalMasters = total // await getMasterSuppliersCount(searchList)

      const childSupPhones = childSuppliersData?.map(data => data?.phone && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.phone) && /^\d+$/.test(data?.phone) ? data?.phone : null)
      const childSupEmails = childSuppliersData?.map(data => data?.email && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.email) && /^\d+$/.test(data?.email) ? data?.email : null)
      let contactIds = []
      let allContactIds = contactIds.concat(supEmails, supPhones, cardPhones, cardIvrPhones, paymentEmails, cardEmails, childSupPhones, childSupEmails);
      contactIds = allContactIds?.filter(data => data && /^\d+$/.test(data))
      const uniqueContactIds = [...new Set(contactIds)]

      if (uniqueContactIds && uniqueContactIds?.length) {
        res['data'].contacts = await getAllContactsByIds(uniqueContactIds, dispatch)
      } else {
        res['data'].contacts = []
      }

      for (var i = 0; i < suppliers.length; i++) {
        const cardData = cardAccData?.find(cardData => cardData?.supplierId === suppliers?.[i]?.id)
        const payment = paymentData?.find(payment => payment?.supplierId === suppliers?.[i]?.id)
        const supDetail = supDetailsData?.find(detail => detail?.supplierId === suppliers?.[i]?.id)
        const supplierQARole = supDetail?.approvedByQA
        const isAcceptGlobalAcceptance = await cardData?.isAcceptGlobalAcceptance
        const cardEmails = cardEmailsData?.filter(email => email?.supplierId === suppliers?.[i]?.id)

        // Child Suppliers
        const childSuppliers = childSuppliersData?.filter(sup => sup?.masterId === suppliers?.[i]?.id || sup?.primaryMasterId === suppliers?.[i]?.id)

        var tmpChildSuppliers = []
        if (childSuppliers && childSuppliers.length > 0) {
          for (var j = 0; j < childSuppliers.length; j++) {
            const supplierQARole = childSuppliers?.[j]?.supplierDetail?.approvedByQA
            tmpChildSuppliers[j] = childSuppliers?.[j];
            tmpChildSuppliers[j].phone = tmpChildSuppliers[j]?.phone && /^\d+$/.test(tmpChildSuppliers[j]?.phone) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpChildSuppliers[j]?.phone) ? res['data'].contacts?.find(data => data?.id === parseInt(tmpChildSuppliers[j]?.phone))?.phone : (tmpChildSuppliers[j]?.phone || '')
            tmpChildSuppliers[j].email = tmpChildSuppliers[j]?.email && /^\d+$/.test(tmpChildSuppliers[j]?.email) ? res['data'].contacts?.find(data => data?.id === parseInt(tmpChildSuppliers[j]?.email))?.email : (tmpChildSuppliers[j]?.email || '')
            tmpChildSuppliers[j]['supplierQARole'] = supplierQARole === 8 ? 'Approved' : supplierQARole === 7 ? 'Rejected' : 'Pending'
          }
        }

        tmpSuppliers[i] = suppliers?.[i];
        tmpSuppliers[i]['supplierQARole'] = (suppliers?.[i]?.isInCalls || supplierQARole === 9) ? 'In Calls' : supplierQARole === 8 ? 'Approved' : supplierQARole === 7 ? 'Rejected' : 'Pending'
        tmpSuppliers[i]['isAcceptGlobalAcceptance'] = isAcceptGlobalAcceptance === null ? 'Unknown' : isAcceptGlobalAcceptance ? 'Yes' : 'No'
        tmpSuppliers[i]['relatedSuppliersCount'] = childSuppliers?.length
        tmpSuppliers[i]['cardEmailsInfo'] = cardEmails
        tmpSuppliers[i]['childVendors'] = tmpChildSuppliers
        tmpSuppliers[i]['cardAcceptance'] = cardData || {}
        tmpSuppliers[i]['payment'] = payment || {}
        tmpSuppliers[i]['supplierDetail'] = supDetail || {}
        // set email and phone
        tmpSuppliers[i].phone = tmpSuppliers[i]?.phone && /^\d+$/.test(tmpSuppliers[i]?.phone) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpSuppliers[i]?.phone) ? res['data'].contacts?.find(data => data?.id === parseInt(tmpSuppliers[i]?.phone))?.phone : (tmpSuppliers[i]?.phone || '')
        tmpSuppliers[i].email = tmpSuppliers[i]?.email && /^\d+$/.test(tmpSuppliers[i]?.email) ? res['data'].contacts?.find(data => data?.id === parseInt(tmpSuppliers[i]?.email))?.email : (tmpSuppliers[i]?.email || '')
        tmpSuppliers[i].cardAcceptance.cardPaymentByPhoneValue = tmpSuppliers[i]?.cardAcceptance?.cardPaymentByPhoneValue && /^\d+$/.test(tmpSuppliers[i]?.cardAcceptance?.cardPaymentByPhoneValue) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpSuppliers[i]?.cardAcceptance?.cardPaymentByPhoneValue) ? res['data'].contacts?.find(data => data?.id === parseInt(tmpSuppliers[i]?.cardAcceptance?.cardPaymentByPhoneValue))?.phone : (tmpSuppliers[i]?.cardAcceptance?.cardPaymentByPhoneValue || '')
        tmpSuppliers[i].cardAcceptance.cardPaymentIVRPhone = tmpSuppliers[i]?.cardAcceptance?.cardPaymentIVRPhone && /^\d+$/.test(tmpSuppliers[i]?.cardAcceptance?.cardPaymentIVRPhone) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpSuppliers[i]?.cardAcceptance?.cardPaymentIVRPhone) ? res['data'].contacts?.find(data => data?.id === parseInt(tmpSuppliers[i]?.cardAcceptance?.cardPaymentIVRPhone))?.phone : (tmpSuppliers[i]?.cardAcceptance?.cardPaymentIVRPhone || '')
        tmpSuppliers[i].payment.emailAch = tmpSuppliers[i]?.payment?.emailAch && /^\d+$/.test(tmpSuppliers[i]?.payment?.emailAch) ? res['data'].contacts?.find(data => data?.id === parseInt(tmpSuppliers[i]?.payment?.emailAch))?.email : (tmpSuppliers[i]?.payment?.emailAch || '')
      }
      res['data'].masterSuppliers = tmpSuppliers
    } else {
      res['data'].masterSuppliers = []
      res['data'].totalMasters = 0
    }

    dispatch(getMasterSuppliersSuccess(res['data']?.masterSuppliers, searchListLength, res['data'].contacts))
    return Promise.resolve(res['data'])
  }).catch(err => {
    dispatch(getMasterSuppliersFailed())
    return Promise.reject(err)
  })
}

export const assignMasterStart = () => {
  return { type: ASSIGN_MASTER_START }
}
export const assignMasterSuccess = (data) => {
  return { type: ASSIGN_MASTER_SUCCESS, data }
}
export const assignMasterFailed = () => {
  return { type: ASSIGN_MASTER_FAILED }
}

export const assignMaster = (ids, masterId) => async (dispatch, getState) => {
  const { auth: { token } } = getState()

  dispatch(assignMasterStart())
  return callPost(`/api/supplier/assignMasterSuppliers`, {
    ids: ids,
    masterId: masterId,
  }, token).then((res) => {
    dispatch(assignMasterSuccess(res['data']))
    return Promise.resolve(res['data'])
  }).catch(err => {
    dispatch(assignMasterFailed())
    return Promise.reject(err)
  })
}

export const removeMasterStart = () => {
  return { type: REMOVE_MASTER_START }
}
export const removeMasterSuccess = (data) => {
  return { type: REMOVE_MASTER_SUCCESS, data }
}
export const removeMasterFailed = () => {
  return { type: REMOVE_MASTER_FAILED }
}

export const removeMaster = (ids) => (dispatch, getState) => {
  const { auth: { token } } = getState()

  dispatch(removeMasterStart())
  return callGet(`/api/supplier/removeMasterSuppliers`, token, {
    ids: ids.join(',')
  }).then((res) => {
    dispatch(removeMasterSuccess(res['data']))
    dispatch(getMasterSuppliers())
  }).catch(err => {
    dispatch(removeMasterFailed())
  })
}

export const uploadAchInstruction = (file, onUploadProgress) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  let formData = new FormData()
  formData.append('file', file)

  return axios.post(`/api/supplier/uploadAchInstruction`, formData, {
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
  });
}

export const createMasterFromChilds = ({ childIds, basicData, cardData, paymentData, feeData, primaryMasterId, isFromList, listSupplier, generalInfoData }) => (dispatch, getState) => {
  const { auth: { user, token } } = getState()
  const { id } = user

  dispatch({
    type: CREATE_MASTER_FROM_CHILDS_START
  })
  return callPost('/api/supplier/createMasterFromSuppliers', {
    childIds,
    basicData,
    cardData,
    paymentData,
    userId: id,
    feeData,
    primaryMasterId,
    isFromList,
    listSupplier,
    generalInfoData
  }, token)
    .then(res => {
      dispatch({
        type: CREATE_MASTER_FROM_CHILDS_SUCCESS,
        data: res.data
      })
      toast.show({
        title: 'Success',
        description: 'Successfully created master record',
      })
      return Promise.resolve(res.data)
    }).catch(err => {
      dispatch({
        type: CREATE_MASTER_FROM_CHILDS_FAIL,
        data: err
      })
      toast.show({
        title: 'Warning',
        description: err?.response?.data,
      })
      return Promise.reject({ message: err })
    })
}

export const updateSupplierBasicInfo = ({ supplierId, basicData, supType = 'master', isBasicInfoChanged = false, isEINChanged = false, isUpdateInRedux = true }) => (dispatch, getState) => {
  const { auth: { user, token } } = getState()
  const { id } = user
  dispatch({
    type: UPDATE_SUPPLIER_BASIC_INFO_START
  })
  return callPost('/api/supplier/updateSupplierBasicInfo', {
    supplierId,
    basicData,
    userId: id,
    isEINChanged
  }, token)
    .then(res => {
      dispatch({
        type: UPDATE_SUPPLIER_BASIC_INFO_SUCCESS,
        data: res?.data,
        supType,
        isUpdateInRedux
      })
      toast.show({
        title: 'Success',
        description: 'Successfully update supplier basic information',
      })
      return Promise.resolve(res.data)
    }).catch((err) => {
      dispatch({
        type: UPDATE_SUPPLIER_BASIC_INFO_FAIL,
        data: err
      })
      toast.show({
        title: 'Warning',
        description: err?.response?.data,
      })
      return Promise.reject({ message: err })
    })
}

export const updateSupplierCardInfo = ({ cardId, cardData, feeData, supType = 'master', masterSupplierId, isCardAcceptanceUpdated, isAcceptanceGotUpdatedForSpecificFields, isUpdateInRedux = true }) => (dispatch, getState) => {
  const { auth: { token } } = getState()

  dispatch({
    type: UPDATE_SUPPLIER_CARD_INFO_START
  })
  return callPost('/api/card/updateCardAcceptanceInfo', {
    cardId,
    cardData,
    feeData,
    masterSupplierId,
    isCardAcceptanceUpdated,
    isAcceptanceGotUpdatedForSpecificFields
  }, token)
    .then(res => {
      dispatch({
        type: UPDATE_SUPPLIER_CARD_INFO_SUCCESS,
        data: res.data,
        supType,
        supDetailInfo: isCardAcceptanceUpdated ? res?.data?.supDetailInfo : null,
        isUpdateInRedux
      })
      toast.show({
        title: 'Success',
        description: 'Successfully update card information',
      })
      return Promise.resolve(res.data)
    }).catch(err => {
      dispatch({
        type: UPDATE_SUPPLIER_CARD_INFO_FAIL,
        data: err.message ? err.message : err
      })
      toast.show({
        title: 'Warning',
        description: 'Failed to update card information',
      })
      return Promise.reject({ message: err })
    })
}

export const updateSupplierPaymentInfo = ({ masterSupplierId, paymentId, paymentData, supType = 'master', isPaymentUpdated = false, isUpdateInRedux = true }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  dispatch({
    type: UPDATE_SUPPLIER_PAYMENT_INFO_START
  })
  return callPost('/api/payment/updatePaymentInfo', {
    paymentId,
    paymentData,
    masterSupplierId,
    isPaymentUpdated,
  }, token)
    .then(res => {
      dispatch({
        type: UPDATE_SUPPLIER_PAYMENT_INFO_SUCCESS,
        data: res?.data?.updatedPayment || paymentData,
        supType,
        supDetailInfo: isPaymentUpdated ? res?.data?.supDetailInfo : null,
        isUpdateInRedux
      })

      toast.show({
        title: 'Success',
        description: 'Update payment information successfully',
      })
    }).catch(err => {
      dispatch({
        type: UPDATE_SUPPLIER_PAYMENT_INFO_FAIL,
        data: err
      })
      toast.show({
        title: 'Warning',
        description: 'Failed to update payment information',
      })
      return Promise.reject({ message: err })
    })
}

export const updateSupplierDetailInfo = ({ supplierDetailId, supplierId, detailData, markAsReject = false, isSendForReEnablement = true }) => (dispatch, getState) => {
  const { auth: { token } } = getState()

  dispatch({
    type: UPDATE_SUPPLIER_DETAIL_INFO_START
  })
  return callPost('/api/supplier/updateSupplierDetailInfo', {
    supplierDetailId,
    supplierId,
    detailData,
    markAsReject,
    isSendForReEnablement
  }, token).then(res => {
    dispatch({
      type: UPDATE_SUPPLIER_DETAIL_INFO_SUCCESS,
      data: {
        ...detailData,
        id: supplierDetailId === -1 || !supplierDetailId ? res.data.id : supplierDetailId,
        supplierId: supplierId,
      }
    })
  }).catch(error => {
    dispatch({
      type: UPDATE_SUPPLIER_DETAIL_INFO_FAIL,
      data: error
    })
    toast.show({
      title: 'Warning',
      description: 'Failed to update supplier information'
    })
  })
}

export const getChildSuppliersForQA = (data) => (dispatch, getState) => {
  const { auth: { token }, vendor: { allSuppliers } } = getState()
  const { limit, offset, pending, approved, rejected } = data;

  dispatch({
    type: GET_CHILD_SUPPLIERS_FOR_QA_START,
  })

  return callGet('/api/supplier/getChildSuppliersForQA', token, {
    offset,
    limit,
    pending,
    approved,
    rejected
  }).then(async (res) => {
    const tmpChildSuppliers = res['data']?.map(childSupplier => {
      const masterSupplierIndex = allSuppliers?.findIndex(masterSupplier => masterSupplier.id === childSupplier?.supplier?.masterId)

      const supplierQARole = childSupplier?.approvedByQA
      var supplierData = { ...childSupplier.supplier }
      supplierData['supplierQARole'] = supplierQARole === 8 ? 'Approved' : supplierQARole === 7 ? 'Rejected' : 'Pending'
      supplierData['approvedByQA'] = childSupplier?.approvedByQA
      supplierData['contactNameOld'] = childSupplier?.contactNameOld
      supplierData['contactDate'] = childSupplier?.contactDate
      supplierData['masterSupplierName'] = masterSupplierIndex !== -1 ? allSuppliers[masterSupplierIndex].suppliername : null
      return supplierData
    })
    dispatch({
      type: GET_CHILD_SUPPLIERS_FOR_QA_SUCCSS,
      data: tmpChildSuppliers
    })
    return Promise.resolve(tmpChildSuppliers)
  }).catch(err => {
    dispatch({
      type: GET_CHILD_SUPPLIERS_FOR_QA_FAIL,
      data: err
    })
    toast.show({
      title: 'Warning',
      description: 'Failed to get child suppliers'
    })
  })
}

export const getMasterSuppliersForQA = (data) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  const { limit, offset, pending, approved, rejected, searchList = {} } = data;

  const filterList = JSON?.stringify(data?.searchList);
  dispatch({
    type: GET_MASTER_SUPPLIERS_FOR_QA_START,
  })

  return callGet('/api/supplier/getMasterSuppliersForQA', token, {
    offset,
    limit,
    pending,
    approved,
    rejected,
    searchList: filterList
  }).then(async (res) => {
    let contacts = []
    const childSuppliers = res['data']?.childSuppliers
    const supEmails = res['data']?.suppliers?.map(data => data?.supplier?.email && /^\d+$/.test(data?.supplier?.email) ? data?.supplier?.email : null)
    const supPhones = res['data']?.suppliers?.map(data => data?.supplier?.phone && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.supplier?.phone) && /^\d+$/.test(data?.supplier?.phone) ? data?.supplier?.phone : null)
    const cardPhones = res['data']?.cardAcceptances?.map(data => data?.cardPaymentByPhoneValue && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.cardPaymentByPhoneValue) && /^\d+$/.test(data?.cardPaymentByPhoneValue) ? data?.cardPaymentByPhoneValue : null)
    const cardIvrPhones = res['data']?.cardAcceptances?.map(data => data?.cardPaymentIVRPhone && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.cardPaymentIVRPhone) && /^\d+$/.test(data?.cardPaymentIVRPhone) ? data?.cardPaymentIVRPhone : null)
    const paymentEmails = res['data']?.payments?.map(data => data?.emailAch && /^\d+$/.test(data?.emailAch) ? data?.emailAch : null)
    let contactIds = []
    let allContactIds = contactIds.concat(supEmails, supPhones, cardPhones, cardIvrPhones, paymentEmails);
    contactIds = allContactIds?.filter(data => data && /^\d+$/.test(data))
    const uniqueContactIds = [...new Set(contactIds)]

    if (uniqueContactIds && uniqueContactIds?.length) {
      contacts = await getAllContactsByIds(uniqueContactIds, dispatch)
    }

    const tmpSuppliers = res['data']?.suppliers?.map((supplierDetail) => {
      let max;
      let supId = supplierDetail?.supplier?.id
      let supPayment = res['data']?.payments?.find((payment) => payment?.supplierId === supId)
      let supAcceptance = res['data']?.cardAcceptances?.find((card) => card?.supplierId === supId)

      supplierDetail.supplier['cardAcceptance'] = supAcceptance || null
      supplierDetail.supplier['payment'] = supPayment || null

      const supplierQARole = supplierDetail?.approvedByQA
      var supplierData = { ...supplierDetail?.supplier }
      supplierData['supplierQARole'] = supplierQARole === 8 ? 'Approved' : supplierQARole === 7 ? 'Rejected' : (supplierQARole === 9 || supplierDetail?.supplier?.isInCalls === true) ? 'In Calls' : 'Pending'
      supplierData['approvedByQA'] = supplierDetail?.approvedByQA;

      const masterChildContactDates = []
      const filter = childSuppliers.filter(childSupplier => {
        if (childSupplier?.masterId === supplierDetail?.supplierId) {
          masterChildContactDates.push(childSupplier?.supplierDetail?.contactDate || '')
        }
      })

      supplierData["contactDate"] = masterChildContactDates;
      if (supplierData?.["contactDate"]?.length === 0) {
        supplierData["maxContactedDate"] = null;
      } else {
        max = supplierData?.["contactDate"]?.reduce(function (a, b) { return a > b ? a : b; });
        supplierData["maxContactedDate"] = new Date(max).toLocaleDateString("en-US", { year: "numeric", month: "2-digit", day: "2-digit" });
      }
      // set phone and email
      supplierData.phone = supplierData?.phone && /^\d+$/.test(supplierData?.phone) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(supplierData?.phone) ? contacts?.find(data => data?.id === parseInt(supplierData?.phone))?.phone : (supplierData?.phone || '')
      supplierData.email = supplierData?.email && /^\d+$/.test(supplierData?.email) ? contacts?.find(data => data?.id === parseInt(supplierData?.email))?.email : (supplierData?.email || '')
      supplierData.cardAcceptance.cardPaymentByPhoneValue = supplierData?.cardAcceptance?.cardPaymentByPhoneValue && /^\d+$/.test(supplierData?.cardAcceptance?.cardPaymentByPhoneValue) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(supplierData?.cardAcceptance?.cardPaymentByPhoneValue) ? contacts?.find(data => data?.id === parseInt(supplierData?.cardAcceptance?.cardPaymentByPhoneValue))?.phone : (supplierData?.cardAcceptance?.cardPaymentByPhoneValue || '')
      supplierData.cardAcceptance.cardPaymentIVRPhone = supplierData?.cardAcceptance?.cardPaymentIVRPhone && /^\d+$/.test(supplierData?.cardAcceptance?.cardPaymentIVRPhone) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(supplierData?.cardAcceptance?.cardPaymentIVRPhone) ? contacts?.find(data => data?.id === parseInt(supplierData?.cardAcceptance?.cardPaymentIVRPhone))?.phone : (supplierData?.cardAcceptance?.cardPaymentIVRPhone || '')
      supplierData.payment.emailAch = supplierData?.payment?.emailAch && /^\d+$/.test(supplierData?.payment?.emailAch) ? contacts?.find(data => data?.id === parseInt(supplierData?.payment?.emailAch))?.email : (supplierData?.payment?.emailAch || '')
      return supplierData;
    })

    dispatch({
      type: GET_MASTER_SUPPLIERS_FOR_QA_SUCCSS,
      data: tmpSuppliers
    })
    return Promise.resolve(tmpSuppliers)
  }).catch(err => {
    dispatch({
      type: GET_MASTER_SUPPLIERS_FOR_QA_FAIL,
      data: err
    })
    toast.show({
      title: 'Warning',
      description: 'Failed to get master suppliers'
    })
  })
}

export const approveSuppliers = ({ ids, supplierType }) => (dispatch, getState) => {
  const { auth: { token } } = getState()

  dispatch({
    type: APPROVE_SUPPLIERS_START,
  })

  return callPost('/api/supplier/approveSuppliers', {
    ids: ids,
  }, token).then(res => {
    if (supplierType) {
      dispatch({
        type: APPROVE_SUPPLIERS_SUCCESS,
        data: {
          type: supplierType,
          updatedSupplierDetails: res['data']
        }
      })
    }
    toast.show({
      title: 'Success',
      description: (supplierType === 'singleMaster' || supplierType === 'singleChild') ? 'Supplier has been approved successfully' : 'Selected suppliers have been approved successfully'
    })
  }).catch(err => {
    console.log(err)
    dispatch({
      type: APPROVE_SUPPLIERS_FAIL,
      data: err
    })
    toast.show({
      title: 'Warning',
      description: 'Failed to approve suppliers'
    })
  })
}

export const rejectSuppliers = ({ ids, supplierType, isReenable = false }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  dispatch({
    type: REJECT_SUPPLIERS_START,
  })

  return callPost('/api/supplier/rejectSuppliers', {
    ids: ids,
    isReenable
  }, token).then(res => {
    if (supplierType) {
      dispatch({
        type: REJECT_SUPPLIERS_SUCCESS,
        data: {
          type: supplierType,
          updatedSupplierDetails: res['data']
        }
      })
    }
    toast.show({
      title: 'Success',
      description: (supplierType === 'singleMaster' || supplierType === 'singleChild') ? 'Supplier has been rejected successfully' : 'Selected suppliers have been rejected successfully'
    })

  }).catch(err => {
    dispatch({
      type: REJECT_SUPPLIERS_FAIL,
      data: err
    })
    toast.show({
      title: 'Warning',
      description: 'Failed to reject suppliers'
    })
  })
}

export const addCardAcceptanceEmails = ({ supplierId, userId, cardEmailsData, supType = 'master', listSupplierId, vendorInCallsDetailsId, masterId = null, isCardAcceptanceUpdated }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  const emailsData = cardEmailsData.addEmailValues
  if (supType !== 'listSupplier') {
    dispatch({
      type: ADD_SUPPLIER_CARD_EMAIL_INFO_START
    })
  }

  return callPost('/api/card/addCardAcceptanceEmails', {
    supplierId,
    userId,
    emailsData,
    listSupplierId,
    vendorInCallsDetailsId,
    masterId,
    isCardAcceptanceUpdated
  }, token)
    .then(res => {
      if (supType !== 'listSupplier') {
        dispatch({
          type: ADD_SUPPLIER_CARD_EMAIL_INFO_SUCCESS,
          data: res,
          supType
        })
      }
      toast.show({
        title: 'Success',
        description: 'Sucessufully added card acceptance emails',
      })
      return Promise.resolve(res['data'])
    }).catch(err => {
      if (supType !== 'listSupplier') {
        dispatch({
          type: ADD_SUPPLIER_CARD_EMAIL_INFO_FAIL,
          data: err
        })
      }
      toast.show({
        title: 'Warning',
        description: 'Failed to add card acceptance emails',
      })
      return Promise.reject({ message: err })
    })
}

export const removeCardAcceptanceEmails = ({ supplierId, removeEmailsData, supType = 'master', listSupplierId, vendorInCallDetailsId = null, masterId = null }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  const removeEmailsValues = removeEmailsData.removeEmailValues
  if (supType !== 'listSupplier') {
    dispatch({
      type: REMOVE_SUPPLIER_CARD_EMAIL_INFO_START
    })
  }

  return callPost('/api/card/removeCardAcceptanceEmails', {
    supplierId,
    removeEmailsValues,
    listSupplierId,
    vendorInCallDetailsId,
    masterId
  }, token)
    .then(res => {
      if (supType !== 'listSupplier') {
        dispatch({
          type: REMOVE_SUPPLIER_CARD_EMAIL_INFO_SUCCESS,
          data: res,
          supType
        })
      }
      return Promise.resolve(res['data'])
    }).catch(err => {
      if (supType !== 'listSupplier') {
        dispatch({
          type: REMOVE_SUPPLIER_CARD_EMAIL_INFO_FAIL,
          data: err
        })
      }
      toast.show({
        title: 'Warning',
        description: 'Failed to remove card acceptance emails',
      })
      return Promise.reject({ message: err })
    })
}

export const uploadCardAuthorizationFormFile = (file) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  let formData = new FormData()
  formData.append('file', file)

  return axios.post(`/api/supplier/uploadCardAuthorizationFormFile`, formData, {
    headers: {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
}

export const getRelatedSupplierDetailsById = (relatedSupplierId) => (dispatch, getState) => {
  const { auth: { token } } = getState()

  dispatch({
    type: GET_RELATED_SUPPLIER_WITH_ID_START
  })
  return callGet(`/api/supplier/getRelatedSupplierDetailById`, token, {
    relatedSupplierId
  }).then((res) => {
    dispatch({
      type: GET_RELATED_SUPPLIER_WITH_ID_SUCCESS,
      data: res['data']
    })
    return Promise.resolve(res['data'])
  }).catch(() => {
    dispatch({
      type: GET_RELATED_SUPPLIER_WITH_ID_FAIL,
    })
    toast.show({
      title: 'Warning',
      description: 'Failed to get child suppliers for this ID!',
    })
  })
}

export const downloadFileFromS3Bucket = (filename) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  if (!filename) {
    toast.show({
      title: 'Warning',
      description: 'No Filename',
    })
    return
  }
  return axios.post(`/api/supplier/downloadFileFromS3Bucket`, filename, {
    responseType: 'blob',
    headers: {
      "Authorization": `Bearer ${token}`,
    },
  })
}

export const addSupplierHistory = (historyData, showToast = true) => (dispatch, getState) => {
  const { supplierId, note, noteType, supplierName, isMaster, isLocationMaster, listSupplierId, isInCalls } = historyData
  const { auth: { user, token } } = getState()
  var userName = user?.firstname + (user?.lastname ? ' ' + user?.lastname : '')
  const { id } = user
  var regex = /<a .*?>/g
  const emailsArray = [...note.matchAll(regex)]
  var emails = []
  emailsArray && emailsArray.map((item) => {
    var hrefRegex = /<a\s+(?:[^>]*?\s+)?href="([^"]*)"/g
    var valueRegex = /<a\s+(?:[^>]*?\s+)?data-value="([^"]*)"/g
    const hrefArray = [...item[0].matchAll(hrefRegex)]
    const valueArray = [...item[0].matchAll(valueRegex)]
    if (hrefArray.length && valueArray.length) {
      const href = hrefArray?.[0]?.[1]
      const value = valueArray?.[0]?.[1]
      emails.push({ email: href.replaceAll('https://', ''), name: value.replaceAll('https://', '') })
    }
  })
  dispatch({
    type: ADD_SUPPLIER_HISTORY_START
  })
  return callPost(`/api/supplier/addSupplierHistory`, {
    supplierId,
    userId: id,
    note,
    noteType,
    userName,
    supplierName,
    emails,
    isMaster,
    isLocationMaster,
    listSupplierId,
    isInCalls
  }, token).then((res) => {
    dispatch({
      type: ADD_SUPPLIER_HISTORY_SUCCESS,
      data: res
    })
    if (showToast) {
      toast.show({
        title: 'Success',
        description: 'Successfully added notes data!'
      })
    }
  }).catch(err => {
    dispatch({
      type: ADD_SUPPLIER_HISTORY_FAIL,
    })
    if (showToast) {
      toast.show({
        title: 'Warning',
        description: 'Failed to add notes data!',
      })
    }
  })
}

export const getChildSuppliersCount = () => (dispatch, getState) => {
  const { auth: { user, token } } = getState()
  const { id } = user

  return callGet(`/api/supplier/getChildSuppliersCount`, token, {
    userId: id
  }).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    console.log(err)
  })
}

export const getMasterSuppliersCount = () => (dispatch, getState) => {
  const { auth: { user, token } } = getState()
  const { id } = user

  return callGet(`/api/supplier/getMasterSuppliersCount`, token, {
    userId: id
  }).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    console.log(err)
  })
}

export const getAllSuppliersData = () => (dispatch, getState) => {
  const { auth: { token } } = getState()
  dispatch({
    type: GET_ALL_SUPPLIERS_DATA_START
  })
  return callGet('/api/supplier/getAllSuppliersData', token, {}).then(async (res) => {
    await dispatch({
      type: GET_ALL_SUPPLIERS_DATA_SUCCESS,
      data: res['data']
    })

    return Promise.resolve(res['data'])
  }).catch(err => {
    dispatch({
      type: GET_ALL_SUPPLIERS_DATA_FAIL
    })
    toast.show({
      title: 'Warning',
      description: 'Failed to get suppliers data'
    })
  })
}

export const checkEmailPhoneLastValidatedDate = ({ valueToValidate, valueType }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet(`/api/card/checkEmailPhoneLastValidatedDate`, token, {
    valueToValidate,
    valueType
  }).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ message: err })
  })
}

export const validatePhoneValue = ({ valueToValidate }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/validate/validatePhone`, {
    phoneNumber: valueToValidate
  }, token).then((res) => {
    return Promise.resolve(res.data)
  }).catch(() => {
    toast.show({
      title: 'Warning',
      description: 'Failed to validate Phone Number!',
    })
  })
}

export const saveEmailOrPhoneValidatedData = ({ valueToValidate, valueType, isValid, isEmailRisky }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/card/saveEmailOrPhoneValidatedData`, {
    valueToValidate,
    valueType,
    isValid,
    isEmailRisky
  }, token).then(() => {
  }).catch(() => {
    toast.show({
      title: 'Warning',
      description: 'Failed to add Validated Data!',
    })
  })
}

export const updateEmailOrPhoneValidatedData = ({ valueToValidate, valueType, isValid, isEmailRisky }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/card/updateEmailOrPhoneValidatedData`, {
    valueToValidate,
    valueType,
    isValid,
    isEmailRisky
  }, token).then(() => {
  }).catch(() => {
    toast.show({
      title: 'Warning',
      description: 'Failed to update Validated Data!',
    })
  })
}

// To validate the email value domain
export const validateEmailValue = ({ valueToValidate }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/validate/validateEmail`, {
    email: valueToValidate
  }, token).then((res) => {
    return Promise.resolve(res.data)
  }).catch(() => {
    toast.show({
      title: 'Warning',
      description: 'Failed to validate Email!',
    })
  })
}

export const removeMasterSupplierDetails = () => (dispatch, getState) => {
  dispatch({
    type: REMOVE_MASTER_SUPPLIER_DETAILS
  })
}

export const getLocationBasedMasterSuppliers = (data) => async (dispatch, getState) => {
  const { auth: { user, token } } = getState()
  const { id } = user
  const { limit, offset, sortColumn, sortType } = data
  var searchListLength = data?.searchList ? Object.keys(data?.searchList)?.length : 0
  var searchList = JSON?.stringify(data?.searchList || {})
  dispatch({
    type: GET_LOCATION_BASED_MASTER_SUPPLIERS_START
  })

  return callGet(`/api/supplier/getLocationBasedMasterSuppliersByUser`, token, {
    userId: id,
    offset: offset,
    limit: limit,
    searchList,
    sortColumn,
    sortType
  }).then(async (res) => {
    let contactIds = []
    let contacts = []
    const suppliers = res?.['data']?.locationMasters
    const cardAccData = res?.['data']?.cardAcceptance || []
    const paymentData = res?.['data']?.paymentData || []
    const supDetailsData = res?.['data']?.supDetails || []
    const total = res?.['data']?.total || 0
    const getMasterSuppliers = async (masterIds) => {
      const data = await dispatch(getMasterSuppliersByIds({ primaryMasterId: null, masterIds })).then(res => {
        return res
      })
      return data
    }

    const getChildSuppliers = async (masterIds) => {
      const data = await dispatch(getChildSuppliersByIds({ isLocationMaster: true, masterIds })).then(res => {
        return res
      })
      return data
    }

    const getLocationMasterSuppliersCount = async (searchList) => {
      const data = await dispatch(getLocationMasterSuppliersByUserCount({ searchList })).then(res => {
        return res?.totalLocationMasters || 0
      })
      return data
    }

    var tmpSuppliers = []
    if (suppliers && suppliers?.length > 0) {
      const masterIds = suppliers?.map(sup => sup?.masterId)
      const supIds = suppliers?.map(sup => sup?.id)
      const masterSuppliers = await getMasterSuppliers(masterIds)
      const relatedSuppliers = await getChildSuppliers(supIds)
      res['data'].totalLocationMasters = total //await getLocationMasterSuppliersCount(searchList)

      const supEmails = suppliers?.map(data => data?.email && /^\d+$/.test(data?.email) ? data?.email : null)
      const supPhones = suppliers?.map(data => data?.phone && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.phone) && /^\d+$/.test(data?.phone) ? data?.phone : null)
      const cardPhones = cardAccData?.map(data => data?.cardPaymentByPhoneValue && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.cardPaymentByPhoneValue) && /^\d+$/.test(data?.cardPaymentByPhoneValue) ? data?.cardPaymentByPhoneValue : null)
      const cardIvrPhones = cardAccData?.map(data => data?.cardPaymentIVRPhone && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.cardPaymentIVRPhone) && /^\d+$/.test(data?.cardPaymentIVRPhone) ? data?.cardPaymentIVRPhone : null)
      const paymentEmails = paymentData?.map(data => data?.emailAch && /^\d+$/.test(data?.emailAch) ? data?.emailAch : null)
      const childSupPhones = relatedSuppliers?.map(data => data?.phone && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.phone) && /^\d+$/.test(data?.phone) ? data?.phone : null)
      const childSupEmails = relatedSuppliers?.map(data => data?.email && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.email) && /^\d+$/.test(data?.email) ? data?.email : null)

      let allContactIds = contactIds.concat(supEmails, supPhones, cardPhones, cardIvrPhones, paymentEmails, childSupPhones, childSupEmails)
      contactIds = allContactIds?.filter(data => data && /^\d+$/.test(data))
      const uniqueContactIds = [...new Set(contactIds)]
      if (uniqueContactIds && uniqueContactIds?.length) {
        contacts = await getAllContactsByIds(uniqueContactIds, dispatch)
      }

      for (var i = 0; i < suppliers.length; i++) {
        const cardData = cardAccData?.find(cardData => cardData?.supplierId === suppliers?.[i]?.id)
        const payment = paymentData?.find(payData => payData?.supplierId === suppliers?.[i]?.id)
        const supDetail = supDetailsData?.find(detail => detail?.supplierId === suppliers?.[i]?.id)
        const supplierQARole = supDetail?.approvedByQA
        const masterSupplierIndex = await masterSuppliers.findIndex(masterSupplier => masterSupplier.id === suppliers?.[i]?.masterId)
        const isAcceptGlobalAcceptance = await cardData?.isAcceptGlobalAcceptance
        // Child Suppliers
        const relatedSuppliersCount = relatedSuppliers?.filter(sup => sup?.masterId === suppliers?.[i]?.id)

        var tmpChildSuppliers = []
        if (relatedSuppliersCount && relatedSuppliersCount.length > 0) {
          for (var j = 0; j < relatedSuppliersCount.length; j++) {
            const supplierQARole = relatedSuppliersCount?.[j]?.supplierDetail?.approvedByQA
            tmpChildSuppliers[j] = relatedSuppliersCount?.[j];
            tmpChildSuppliers[j].phone = tmpChildSuppliers[j]?.phone && /^\d+$/.test(tmpChildSuppliers[j]?.phone) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpChildSuppliers[j]?.phone) ? contacts?.find(data => data?.id === parseInt(tmpChildSuppliers[j]?.phone))?.phone : (tmpChildSuppliers[j]?.phone || '')
            tmpChildSuppliers[j].email = tmpChildSuppliers[j]?.email && /^\d+$/.test(tmpChildSuppliers[j]?.email) ? contacts?.find(data => data?.id === parseInt(tmpChildSuppliers[j]?.email))?.email : (tmpChildSuppliers[j]?.email || '')
            tmpChildSuppliers[j]['supplierQARole'] = supplierQARole === 8 ? 'Approved' : supplierQARole === 7 ? 'Rejected' : 'Pending'
          }
        }

        tmpSuppliers[i] = suppliers?.[i];
        tmpSuppliers[i]['supplierQARole'] = supplierQARole === 8 ? 'Approved' : supplierQARole === 7 ? 'Rejected' : 'Pending'
        tmpSuppliers[i]['primaryMasterSupplierName'] = masterSupplierIndex !== -1 ? masterSuppliers[masterSupplierIndex]?.suppliername : null
        tmpSuppliers[i]['isAcceptGlobalAcceptance'] = isAcceptGlobalAcceptance === null ? 'Unknown' : isAcceptGlobalAcceptance ? 'Yes' : 'No'
        tmpSuppliers[i]['relatedSuppliersCount'] = relatedSuppliersCount?.length || 0
        tmpSuppliers[i]['cardAcceptance'] = cardData || {}
        tmpSuppliers[i]['payment'] = payment || {}
        tmpSuppliers[i]['supplierDetail'] = supDetail || {}
        tmpSuppliers[i]['childVendors'] = tmpChildSuppliers
        // set phone and email
        tmpSuppliers[i].phone = tmpSuppliers[i]?.phone && /^\d+$/.test(tmpSuppliers[i]?.phone) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpSuppliers[i]?.phone) ? contacts?.find(data => data?.id === parseInt(tmpSuppliers[i]?.phone))?.phone : (tmpSuppliers[i]?.phone || '')
        tmpSuppliers[i].email = tmpSuppliers[i]?.email && /^\d+$/.test(tmpSuppliers[i]?.email) ? contacts?.find(data => data?.id === parseInt(tmpSuppliers[i]?.email))?.email : (tmpSuppliers[i]?.email || '')
        tmpSuppliers[i].cardAcceptance.cardPaymentByPhoneValue = tmpSuppliers[i]?.cardAcceptance?.cardPaymentByPhoneValue && /^\d+$/.test(tmpSuppliers[i]?.cardAcceptance?.cardPaymentByPhoneValue) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpSuppliers[i]?.cardAcceptance?.cardPaymentByPhoneValue) ? contacts?.find(data => data?.id === parseInt(tmpSuppliers[i]?.cardAcceptance?.cardPaymentByPhoneValue))?.phone : (tmpSuppliers[i]?.cardAcceptance?.cardPaymentByPhoneValue || '')
        tmpSuppliers[i].cardAcceptance.cardPaymentIVRPhone = tmpSuppliers[i]?.cardAcceptance?.cardPaymentIVRPhone && /^\d+$/.test(tmpSuppliers[i]?.cardAcceptance?.cardPaymentIVRPhone) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpSuppliers[i]?.cardAcceptance?.cardPaymentIVRPhone) ? contacts?.find(data => data?.id === parseInt(tmpSuppliers[i]?.cardAcceptance?.cardPaymentIVRPhone))?.phone : (tmpSuppliers[i]?.cardAcceptance?.cardPaymentIVRPhone || '')
        tmpSuppliers[i].payment.emailAch = tmpSuppliers[i]?.payment?.emailAch && /^\d+$/.test(tmpSuppliers[i]?.payment?.emailAch) ? contacts?.find(data => data?.id === parseInt(tmpSuppliers[i]?.payment?.emailAch))?.email : (tmpSuppliers[i]?.payment?.emailAch || '')
      }

      res['data'].locationMasters = tmpSuppliers
    } else {
      res['data'].locationMasters = []
      res['data'].totalLocationMasters = 0
    }

    dispatch({
      type: GET_LOCATION_BASED_MASTER_SUPPLIERS_SUCCESS,
      data: res['data'].locationMasters,
      searchListLength
    })
    return Promise.resolve(res['data'])
  }).catch(() => {
    dispatch({
      type: GET_LOCATION_BASED_MASTER_SUPPLIERS_FAILED,
    })
  })
}

export const getLocationMasterSuppliersCount = () => (dispatch, getState) => {
  const { auth: { user, token } } = getState()
  const { id } = user

  return callGet(`/api/supplier/getLocationBasedMasterSuppliersCount`, token, {
    userId: id
  }).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    console.log(err)
  })
}

export const linkChildrensToPrimaryMaster = ({ masterId }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/linkChildrensToPrimaryMaster`, {
    masterId
  }, token).then((res) => {
    toast.show({
      title: 'Success',
      description: res.data.message,
    })
  }).catch(() => {
    toast.show({
      title: 'Warning',
      description: 'Failed to link all childs to Primary Master!',
    })
  })
}

export const updateGlobalAcceptance = ({ supplierId, isGlobalAcceptance, supType = 'master' }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/updateGlobalAcceptance`, {
    supplierId,
    isGlobalAcceptance
  }, token).then((res) => {
    toast.show({
      title: 'Success',
      description: res.data.message
    })
    dispatch({
      type: UPDATE_GLOBAL_ACCEPTANCE,
      data: res.data,
      supType
    })
  }).catch(() => {
    toast.show({
      title: 'Warning',
      description: 'Failed to update Global Acceptance!',
    })
  })
}

// get total Global Accepting Suppliers Count
export const getGlobalAcceptingSuppliersCount = () => (dispatch, getState) => {
  const { auth: { token } } = getState()

  return callGet(`/api/supplier/getGlobalAcceptingSuppliersCount`, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    console.log(err)
  })
}

export const getLocationBasedMasterSuppliersForQA = (data) => (dispatch, getState) => {
  const { auth: { token }, vendor: { allSuppliers } } = getState()
  const { limit, offset, pending, approved, rejected, searchList = {} } = data;
  const filterList = JSON?.stringify(data?.searchList);

  dispatch({
    type: GET_LOCATION_BASED_MASTER_SUPPLIERS_FOR_QA_START,
  })

  return callGet('/api/supplier/getLocationBasedMasterSuppliersForQA', token, {
    offset,
    limit,
    pending,
    approved,
    rejected,
    searchList: filterList
  }).then(async (res) => {
    let matchedSuppliers = []
    let contacts = []
    const matchedSuppliersId = res['data']?.map(sup => sup?.supplier?.masterId)

    await dispatch(getSuppliersDataByIds(matchedSuppliersId)).then((res) => {
      matchedSuppliers = res
    }).catch((err) => {
      console.log("err", err.message)
    })

    const supEmails = res['data']?.map(data => data?.supplier?.email && /^\d+$/.test(data?.supplier?.email) ? data?.supplier?.email : null)
    const supPhones = res['data']?.map(data => data?.supplier?.phone && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(data?.supplier?.phone) && /^\d+$/.test(data?.supplier?.phone) ? data?.supplier?.phone : null)
    let contactIds = []
    let allContactIds = contactIds.concat(supEmails, supPhones)
    contactIds = allContactIds?.filter(data => data && /^\d+$/.test(data))
    const uniqueContactIds = [...new Set(contactIds)]

    if (uniqueContactIds && uniqueContactIds?.length) {
      contacts = await getAllContactsByIds(uniqueContactIds, dispatch)
    }

    const tmpLocationSuppliers = res['data']?.map(childSupplier => {
      const masterSupplierIndex = matchedSuppliers?.findIndex(masterSupplier => masterSupplier.id === childSupplier?.supplier?.masterId)
      const supplierQARole = childSupplier?.approvedByQA
      var supplierData = { ...childSupplier?.supplier }
      supplierData['supplierQARole'] = supplierQARole === 8 ? 'Approved' : supplierQARole === 7 ? 'Rejected' : (supplierQARole === 9 || childSupplier?.supplier?.isInCalls) ? 'In Calls' : 'Pending'
      supplierData['approvedByQA'] = childSupplier?.approvedByQA
      supplierData['contactNameOld'] = childSupplier?.contactNameOld
      supplierData['contactDate'] = childSupplier?.contactDate
      supplierData['masterSupplierName'] = masterSupplierIndex !== -1 ? matchedSuppliers?.[masterSupplierIndex]?.suppliername : null

      // set phone and email
      supplierData.phone = supplierData?.phone && /^\d+$/.test(supplierData?.phone) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(supplierData?.phone) ? contacts?.find(data => data?.id === parseInt(supplierData?.phone))?.phone : (supplierData?.phone || '')
      supplierData.email = supplierData?.email && /^\d+$/.test(supplierData?.email) ? contacts?.find(data => data?.id === parseInt(supplierData?.email))?.email : (supplierData?.email || '')
      return supplierData
    })
    dispatch({
      type: GET_LOCATION_BASED_MASTER_SUPPLIERS_FOR_QA_SUCCESS,
      data: tmpLocationSuppliers
    })
    return Promise.resolve(tmpLocationSuppliers)
  }).catch(err => {
    dispatch({
      type: GET_LOCATION_BASED_MASTER_SUPPLIERS_FOR_QA_FAIL,
      data: err
    })
    toast.show({
      title: 'Warning',
      description: 'Failed to get location based master suppliers!'
    })
  })
}

export const getLocationMasterSuppliersCountForQA = (data) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  const { pending, approved, rejected } = data;
  const filterList = JSON?.stringify(data?.searchList);

  return callGet(`/api/supplier/getLocationBasedMasterSuppliersCountForQA`, token, {
    pending,
    approved,
    rejected,
    searchList: filterList
  }).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    console.log(err)
  })
}

export const getChildSuppliersCountForQA = (data) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  const { pending, approved, rejected } = data;

  return callGet(`/api/supplier/getChildSuppliersCountForQA`, token, {
    pending,
    approved,
    rejected
  }).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    console.log(err)
  })
}

export const getMasterSuppliersCountForQA = (data) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  const { pending, approved, rejected } = data;
  const filterList = JSON?.stringify(data?.searchList);

  return callGet(`/api/supplier/getMasterSuppliersCountForQA`, token, {
    pending,
    approved,
    rejected,
    searchList: filterList
  }).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    console.log(err)
  })
}

// API call for Merge Master
export const mergeMasters = ({ selectedMasterId, masterIdsToDelete, childrenToMerge, childrenToNotMerge }) => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/mergeMasterSuppliers`, {
    selectedMasterId,
    masterIdsToDelete,
    childrenToMerge,
    childrenToNotMerge
  }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject(err)
  })
}

// To check that EIN already exists
export const checkEmployerIdNumberExists = ({ employerIdNumber, getEINData = false }) => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/checkEmployerIdNumberExists`, {
    employerIdNumber,
    getEINData
  }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const createChildSupplier = ({ basicData, cardData = {}, paymentData = {}, feeData = [], isCreateMaster = false, isCreatedInSequence = false }) => (dispatch, getState) => {
  const { auth: { user, token }, domain: { currentDomain } } = getState()
  const { id } = user
  const { id: domainId } = currentDomain
  var userName = user?.firstname + (user?.lastname ? ' ' + user?.lastname : '')
  dispatch({
    type: CREATE_CHILD_START
  })
  return callPost('/api/supplier/createChildSupplier', {
    basicData,
    cardData,
    paymentData,
    userId: id,
    feeData,
    domainId,
    isCreateMaster,
    userName,
    isCreatedInSequence
  }, token)
    .then(res => {
      dispatch({
        type: CREATE_CHILD_SUCCESS
      })
      toast.show({
        title: 'Success',
        description: 'Successfully created child record!',
      })
      return Promise.resolve(res.data)
    }).catch(err => {
      dispatch({
        type: CREATE_CHILD_FAIL,
        data: err
      })
      toast.show({
        title: 'Warning',
        description: err?.response?.data,
      })
      return Promise.reject({ message: err })
    })
}

export const createChildSuccess = () => (dispatch, getState) => {
  dispatch({
    type: CREATE_CHILD_SUCCESS
  })
}

export const getAllMasterSuppliersData = () => (dispatch, getState) => {
  const { auth: { token } } = getState()

  dispatch({
    type: GET_ALL_MASTER_SUPPLIERS_DATA_START
  })
  return callGet('/api/supplier/getAllMasterSuppliersData', token, {}).then(res => {
    dispatch({
      type: GET_ALL_MASTER_SUPPLIERS_DATA_SUCCESS,
      data: res['data']
    })
    return Promise.resolve(res['data'])
  }).catch(err => {
    dispatch({
      type: GET_ALL_MASTER_SUPPLIERS_DATA_FAIL
    })
    toast.show({
      title: 'Warning',
      description: 'Failed to get master suppliers data'
    })
    return Promise.reject({ message: err })
  })
}

export const getListsData = (data) => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  const { limit, offset } = data;
  var filterData = JSON?.stringify(data?.filterData)
  return callGet('/api/supplier/getListsData', token, {
    offset: offset,
    limit: limit,
    filterData
  }).then(res => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    toast.show({
      title: 'Warning',
      description: 'Failed to get list suppliers data!'
    })
    return Promise.reject({ message: err })
  })
}

export const getListDataById = (listId) => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet('/api/supplier/getListDataById', token, { listId }).then(res => {
    return Promise.resolve(res['data'])
  }).catch((err) => {
    toast.show({
      title: 'Warning',
      description: 'Failed to get list suppliers data'
    })
    return Promise.reject({ message: err })
  })
}

export const markListComplete = (listId, listSuppliers) => async (dispatch, getState) => {
  const { auth: { user, token }, domain: { currentDomain } } = getState()
  const { id: userId } = user
  const { id: domainId } = currentDomain
  let result;
  try {
    result = await callPost('/api/supplier/markListAsComplete', {
      listId,
      listSuppliers,
      userId,
      domainId
    }, token)
    toast.show({
      title: 'Success',
      description: 'List Marked as Complete is in progress!',
    })
  } catch (error) {
    toast.show({
      title: 'Warning',
      description: 'Failed to Mark list as complete!'
    })
    return error
  }
}

export const approveOrRejectListSupplier = (id, type) => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost('/api/supplier/approveOrRejectListSupplier', {
    id,
    type
  }, token)
    .then(res => {
      return Promise.resolve(res['data'])
    }).catch((err) => {
      return Promise.reject({ err })
    })
}

export const matchListSupplierToSupplier = ({ id, matchedSupplierId, status }) => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost('/api/supplier/matchListSupplierToSupplier', {
    id,
    matchedSupplierId,
    status
  }, token)
    .then(res => {
      return Promise.resolve(res['data'])
    }).catch((err) => {
      return Promise.reject({ err })
    })
}

export const addRejectedListSupplierColumns = (data, listSupplierId) => async (dispatch, getState) => {
  const { auth: { user, token } } = getState()
  const { id } = user
  return callPost('/api/supplier/addRejectedListSupplierColumns', {
    data,
    listSupplierId,
    userId: id
  }, token)
    .then(res => {
      return Promise.resolve(res['data'])
    }).catch((err) => {
      return Promise.reject({ err })
    })
}

// to get List Customer Names
export const getCustomerNames = () => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet('/api/supplier/getCustomerNames', token, {}).then(res => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    toast.show({
      title: 'Warning',
      description: 'Failed to get Customer Names!'
    })
    return Promise.reject({ err })
  })
}

export const getAllCustomerNames = () => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet('/api/supplier/getAllCustomerNames', token, {}).then(res => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    toast.show({
      title: 'Warning',
      description: 'Failed to get Customer Names!'
    })
    return Promise.reject({ err })
  })
}

export const getSuppliersWithCardAcceptanceData = (matchedSuppliersIds = [], listSuppliersIds = [], masterSupplierIds = []) => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  const uniqueSupplierIds = matchedSuppliersIds.filter((item, index) => matchedSuppliersIds.indexOf(item) === index)
  return callPost('/api/card/getSuppliersWithCardAcceptanceData', {
    matchedSuppliersIds: JSON?.stringify(uniqueSupplierIds),
    listSuppliersIds: JSON?.stringify(listSuppliersIds),
    masterSupplierIds: JSON?.stringify(masterSupplierIds)
  }, token).then(res => {
    return Promise.resolve(res['data'])
  }).catch((err) => {
    toast.show({
      title: 'Warning',
      description: 'Failed to get Supplier Card Acceptance Data!'
    })
    return Promise.reject({ err })
  })
}

// get total Unassigned Child Suppliers
export const getUnassignedChildSuppliersCount = () => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet(`/api/supplier/getUnassignedChildSuppliersCount`, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject(err)
  })
}

// get total Suppliers in QA
export const getSuppliersInQaCount = () => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet(`/api/supplier/getSuppliersInQaCount`, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject(err)
  })
}

// get total cardable masters count
export const getCardableMastersCount = () => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet(`/api/supplier/getCardableMastersCount`, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject(err)
  })
}

// get total Suppliers Without Card Acceptance
export const getSuppliersWithoutCardAcceptanceCount = () => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet(`/api/supplier/getSuppliersWithoutCardAcceptanceCount`, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getSuppliersInSequenceCount = () => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet(`/api/supplier/getSuppliersInSequenceCount`, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject(err)
  })
}

// get Top Cardable Suppliers
export const getTopCardableSuppliers = () => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet(`/api/supplier/getTopCardableSuppliers`, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject(err)
  })
}

// get Top Suppliers Opportunities With Unknown Acceptance
export const getTopOpportunitiesWithUnknownAcceptance = () => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet(`/api/supplier/getTopOpportunitiesWithUnknownAcceptance`, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject(err)
  })
}

// get Top Suppliers Opportunities With No Acceptance
export const getTopOpportunitiesWithNoAcceptance = () => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet(`/api/supplier/getTopOpportunitiesWithNoAcceptance`, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject(err)
  })
}

// get total Suppliers Without Card Acceptance
export const getSuppliersAddedByPerUser = (domainUserIds) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/getSuppliersAddedByPerUser`, {
    domainUserIds
  }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject(err)
  })
}

export const getListDetails = (listIds) => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost('/api/supplier/getListDetails', { listIds }, token).then(res => {
    return Promise.resolve(res['data'])
  }).catch((err) => {
    toast.show({
      title: 'Warning',
      description: 'Failed to get list details!'
    })
    return Promise.reject({ err })
  })
}

export const getListsTotalSpend = (listIds) => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost('/api/supplier/getListsTotalSpend', { listIds }, token).then(res => {
    return Promise.resolve(res['data'])
  }).catch((err) => {
    toast.show({
      title: 'Warning',
      description: 'Failed to get lists total spend!'
    })
    return Promise.reject(err)
  })
}

export const getListCardableSpend = (listId) => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet('/api/supplier/getListCardableSpend', token, { listId }).then(res => {
    return Promise.resolve(res['data'])
  }).catch((err) => {
    toast.show({
      title: 'Warning',
      description: 'Failed to get list cardable spend!'
    })
    return Promise.reject(err)
  })
}

export const getListSuppliersByListId = (listId, offset, limit) => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet('/api/supplier/getListSuppliersByListId', token, { listId, offset, limit }).then(res => {
    return Promise.resolve(res['data'])
  }).catch((err) => {
    toast.show({
      title: 'Warning',
      description: 'Failed to get all list suppliers!'
    })
    return Promise.reject(err)
  })
}

export const getListSuppliers = ({ listId, type, limit, offset, search, sortColumn, sortType, isMarkListComplete = false, isGetAcceptanceInfo = false, isGetAllColumns = false, fromCreateMasterModal = false }) => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet('/api/supplier/getListSuppliers', token, {
    listId,
    type,
    limit,
    offset,
    search,
    sortColumn,
    sortType,
    isMarkListComplete,
    isGetAcceptanceInfo,
    isGetAllColumns,
    fromCreateMasterModal
  }).then(res => {
    let tmpListdata = {
      totalListSuppliers: res['data']?.totalListSuppliers,
      contacts: res['data']?.contacts
    }

    if (!res['data']?.isMatchedSupplierData) {
      tmpListdata['listSuppliers'] = res['data']?.listSuppliers.map((listSupplier) => {
        let tmpCardAcceptance = res['data']?.cardAcceptanceResults?.find(cardAcceptance => cardAcceptance?.listSupplierId === listSupplier?.id)
        let tmpPayment = res['data']?.paymentResults?.find(cardAcceptance => cardAcceptance?.listSupplierId === listSupplier?.id)
        let tmpSupplierDetail = res['data']?.supplierDetailsResult?.find(cardAcceptance => cardAcceptance?.listSupplierId === listSupplier?.id)
        listSupplier['cardAcceptance'] = tmpCardAcceptance
        listSupplier['payment'] = tmpPayment
        listSupplier['supplierDetail'] = tmpSupplierDetail
        return listSupplier
      });
    }

    if (res['data'].isMatchedSupplierData) {
      const searchedData = []
      res['data']?.suppliersResult?.map((supplier) => {
        let tmpListSup = res['data']?.listSupResults?.find(listSupplier => listSupplier?.matchedSupplierId === supplier?.id)
        if (tmpListSup) {
          searchedData.push(tmpListSup)
        }
      });
      return Promise.resolve({ listSuppliers: searchedData, totalListSuppliers: searchedData?.length })
    } else {
      return Promise.resolve(tmpListdata)
    }
  }).catch((err) => {
    toast.show({
      title: 'Warning',
      description: 'Failed to get all list suppliers!'
    })
    return Promise.reject(err)
  })
}

export const getQaListVendorsByListId = (listId) => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet('/api/supplier/getQaListVendorsByListId', token, { listId }).then(res => {
    return Promise.resolve(res['data'])
  }).catch((err) => {
    toast.show({
      title: 'Warning',
      description: 'Failed to get QA List suppliers!'
    })
    return Promise.reject(err)
  })
}

export const getListSupplierDetailById = (listSupId) => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet('/api/supplier/getListSupplierDetailById', token, { id: listSupId }).then(res => {
    return Promise.resolve(res['data'])
  }).catch((err) => {
    toast.show({
      title: 'Warning',
      description: 'Failed to get List supplier details!'
    })
    return Promise.reject(err)
  })
}

export const getSearchTerm = (searchKey) => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet('/api/supplier/globalSearch', token, { searchKey })
    .then((res) => {
      return Promise.resolve(res['data'])
    }).catch((err) => {
      return Promise.reject(err)
    })
}

export const getCardAcceptanceEmails = (listSupplierId = null, vendorInCallsDetailsId = null, isInCalls = false, supplierId = null) => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet('/api/card/getCardAcceptanceEmails', token, {
    listSupplierId,
    vendorInCallsDetailsId,
    isInCalls,
    supplierId
  }
  ).then(res => {
    return Promise.resolve(res['data']?.cardEmails || [])
  }).catch((err) => {
    toast.show({
      title: 'Warning',
      description: 'Failed to get Supplier Card Emails!'
    })
    return Promise.reject({ err })
  })
}

export const getCardAcceptanceFee = (listSupplierId = null, vendorInCallsDetailsId = null, isInCalls = false, supplierId = null) => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet('/api/card/getCardAcceptanceFee', token, {
    listSupplierId,
    vendorInCallsDetailsId,
    isInCalls,
    supplierId
  }
  ).then(res => {
    return Promise.resolve(res['data']?.cardFeeData || [])
  }).catch((err) => {
    toast.show({
      title: 'Warning',
      description: 'Failed to get Supplier Card Fee Data!'
    })
    return Promise.reject({ err })
  })
}

export const getHistoryData = (listSupplierId = null, vendorInCallsDetailsId = null, isInCalls = false, supplierId = null) => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet('/api/supplier/getHistoryData', token, {
    listSupplierId,
    vendorInCallsDetailsId,
    isInCalls,
    supplierId
  }
  ).then(res => {
    return Promise.resolve(res['data']?.historyData || [])
  }).catch((err) => {
    toast.show({
      title: 'Warning',
      description: 'Failed to get history data!'
    })
    return Promise.reject({ err })
  })
}

export const createChildForListSupplier = (id, matchedSupplierId, domainId, userId, listId, masterSupplierId) => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost('/api/supplier/createChildForListSupplier', {
    id,
    domainId,
    userId,
    masterSupplierId,
    listId
  }, token
  ).then(res => {
    return Promise.resolve(res['data'])
  }).catch((err) => {
    return Promise.reject({ err })
  })
}

export const getMasterSuppliersByIds = ({ primaryMasterId = false, masterIds }) => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost('/api/supplier/getMasterSuppliersByIds', { masterIds, primaryMasterId }, token
  ).then(res => {
    return Promise.resolve(res['data']?.masterSuppliers || [])
  }).catch((err) => {
    toast.show({
      title: 'Warning',
      description: 'Failed to get master suppliers by Ids!'
    })
    return Promise.reject({ err })
  })
}

export const getChildSuppliersByIds = ({ isLocationMaster = false, masterIds }) => async (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost('/api/supplier/getChildSuppliersByIds', { masterIds, isLocationMaster }, token
  ).then(res => {
    return Promise.resolve(res['data']?.childSuppliers || [])
  }).catch((err) => {
    toast.show({
      title: 'Warning',
      description: 'Failed to get child suppliers by master Ids!'
    })
    return Promise.reject({ err })
  })
}

export const getChildSuppliersByUserCount = (data) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  const { noMaster, hasMaster, searchList } = data;

  return callGet(`/api/supplier/getChildSuppliersByUserCount`, token, {
    searchList: searchList,
    noMaster,
    hasMaster
  }).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    console.log(err)
  })
}

export const getMasterSuppliersByUserCount = (data) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  const { searchList } = data;

  return callGet(`/api/supplier/getMasterSuppliersByUserCount`, token, {
    searchList
  }).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    console.log(err)
  })
}

export const getLocationMasterSuppliersByUserCount = (data) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  const { searchList } = data;

  return callGet(`/api/supplier/getLocationMasterSuppliersByUserCount`, token, {
    searchList
  }).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    console.log(err)
  })
}

export const getSuppliersDataByIds = (supplierIds = [], listSupplierIds = [], getMasterData = false) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/getSuppliersDataByIds`, { supplierIds, listSupplierIds, getMasterData }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    console.log(err)
  })
}

export const rerunUnmatchedListSuppliers = ({ data, listId }) => (dispatch, getState) => {
  const { auth: { user, token } } = getState()
  const { id: userId } = user
  return callPost(`/api/supplier/rerunUnmatchedListSuppliers`, { data, listId, userId }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    console.log(err)
  })
}

export const assignChildToMasterSupplier = ({ supplierId, masterId }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost('/api/supplier/assignChildToMasterSupplier', {
    supplierId,
    masterId
  }, token)
    .then(res => {
      toast.show({
        title: 'Success',
        description: 'Successfully assigned child to master!',
      })
      return Promise.resolve(res.data)
    }).catch((err) => {
      toast.show({
        title: 'Warning',
        description: err?.response?.data,
      })
      return Promise.reject({ message: err })
    })
}

export const rerunUnmatchedListSupplier = ({ selectedVendor }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/rerunUnmatchedListSupplier`, { selectedVendor }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    console.log(err)
  })
}

export const approvedAfterRerun = (listSupplierId, matchedSupplier, masterId) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/approvedAfterRerun`, { listSupplierId, matchedSupplier, masterId }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}

export const updateThreshold = (thresholdValue) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/update-threshold`, { thresholdValue }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}

export const getMatchingThreshold = () => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet(`/api/supplier/get-matching-threshold`, token, {}).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}

// get location masters created from Main Master when global acceptance of Main Master is set to False
export const getLocationMastersByMasterIds = (masterIds) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/getLocationMastersByMasterIds`, { masterIds }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}

export const updateCompletenessScore = (supplierId) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/updateCompletenessScore`, { supplierId }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}

export const getMatchedChildOrphans = (page, limit, offset, searchList = {}, sortType, sortColumn) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet(`/api/supplier/get-matched-child-orphans`, token, { page, limit, offset, searchList: JSON?.stringify(searchList), sortType, sortColumn }).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}

export const addEmailDomainWithWeightage = (emailDomain, update, id) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/addEmailDomainWithWeightage`, { emailDomain, update, id }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}


export const getAllEmailsDomainWeights = () => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet(`/api/supplier/getAllEmailsDomainWeights`, token, {},).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}

export const deleteEmailDomain = (emailDomainId) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/deleteEmailDomain`, { emailDomainId }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}

export const checkExistingMastersByName = (supplierNames = []) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/checkExistingMastersByName`, { supplierNames: JSON?.stringify(supplierNames) }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}

export const removeMatchedSupplierForListSupplier = (listSupplierIds) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/removeMatchedSupplierForListSupplier`, { listSupplierIds }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}

export const deleteListSupplier = (listSupplierId) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/deleteListSupplier`, { listSupplierId }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}


export const updateReEnablement = (checkedIds) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/updateReEnablement`, { checkedIds }, token).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    console.log(err)
  })
}

export const checkQaPendingListSuppliers = (listId) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet(`/api/supplier/checkQaPendingListSuppliers`, token, { listId }).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}


export const getAllContactsByIds = async (contactIds = [], dispatch) => {
  const data = await dispatch(getContactsByIds({ contactIds })).then(res => {
    if (typeof res === 'object' && res?.hasOwnProperty('contacts')) {
      return res?.contacts || []
    }
    return res || []
  })
  return data
}

export const getSuppliersQaInfo = (listId) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet(`/api/supplier/getSuppliersQaInfo`, token, { listId }).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}

export const getEnablementResultsTable = (listId) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callGet(`/api/supplier/getEnablementResultsTable`, token, { listId }).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}


export const pauseOrResumeSequencingToListId = ({ listId, operation, listSupplierId, onlyUpdateSupplier = false }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/pauseOrResumeSequencingToListId`, { listId, operation, listSupplierId, onlyUpdateSupplier }, token,).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}

export const unassigningSuppliers = ({ listSupplierIds }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/unassigningSuppliers`, { listSupplierIds }, token,).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}

export const stopOrResumeSequencing = ({ listSupplierId, note, operation, listId }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/stopOrResumeSequencing`, { listSupplierId, note, operation, listId }, token,).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}

export const getCallersIdFromChildSupplier = (listSupplierIds) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/caller/getCallersIdFromChildSupplier`, { listSupplierIds }, token,).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}
export const getAllParentOrganizations = (value = '') => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/getAllParentOrganizations`, { value }, token,).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}

export const createParentOrganizations = (value = '') => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/createParentOrganizations`, { value }, token,).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}

export const getMatchedListSuppliersBySupplierIds = ({ supplierIds, listSupplierIds }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/getMatchedListSuppliersBySupplierIds`, { supplierIds, listSupplierIds }, token,).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}

export const getSupplierNameById = (ids, type) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/getSupplierNameById`, { ids, type }, token,).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}

export const getListSupplierCountByListId = ({ listId, type }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/getListSupplierCountByListId`, { listId, type }, token,).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}

export const getMaxLastHistoricalPayment = ({ masterIds = [] }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/getMaxLastHistoricalPayment`, { masterIds }, token,).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}

export const getLastSetteledPaymentDate = ({ masterIds = [] }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/getLastSetteledPaymentDate`, { masterIds }, token,).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}

export const getLastEnablementDate = ({ masterIds = [] }) => (dispatch, getState) => {
  const { auth: { token } } = getState()
  return callPost(`/api/supplier/getLastEnablementDate`, { masterIds }, token,).then((res) => {
    return Promise.resolve(res['data'])
  }).catch(err => {
    return Promise.reject({ err })
  })
}